<template>
  <div class="pop-confirm">
    <el-popconfirm
      :title="title"
      @onConfirm="onConfirm"
      cancelButtonText='否'
      cancelButtonType="primary"
      confirmButtonText='是'
      confirmButtonType="Text"
      icon="el-icon-info"
      iconColor="red"
    >
      <slot slot="reference"></slot>
    </el-popconfirm>
  </div>
</template>

<script>
export default {
  name: 'popConfirmRed',
  props: ['title'],
  methods: {
    onConfirm () {
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped>
  .pop-confirm {
    display: inline;
    margin-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ApplyBasic/component/PopConfirmRed.vue